import { fetchApi, getFetchApiJSONResponse } from 'shared/functions';
import { ESGUpdateYear } from '../../modules/ESG/types';

export const esgAvailable = (id: string) =>
  fetchApi(`/esg/api/years/${id}/`).then(getFetchApiJSONResponse);

export const regionImpactService = (id: string, params?: ESGUpdateYear) =>
  fetchApi(`/esg/api/${id}/dashboard/total-esg-impact-by-region/`, { query: params }).then(
    getFetchApiJSONResponse,
  );

export const industryImpactService = (id: string, params?: ESGUpdateYear) =>
  fetchApi(`/esg/api/${id}/dashboard/total-esg-impact-by-industry/`, { query: params }).then(
    getFetchApiJSONResponse,
  );
